import VerificationPage from './VerificationPage';

export { VerificationPage };
